export const piecesPerPackageCount = 20 as const
